import { useEffect } from 'react';

// 初始化图片
function useInitImg(imgArr) {
  useEffect(() => {
    imgArr.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);
}

export default useInitImg;
